import React from "react";
import { FaEye, FaIdCard } from "react-icons/fa";

import {
  DEFAULT_AVATAR,
  formatDateShort,
  getAdherentName,
  getAdherentPhoto,
  getAgeLabel,
  getGenreStyle,
} from "../utils/adminAdherentsUtils";

function AdherentsMobileList({ adherents = [], onOpen }) {
  return (
    <section className="space-y-3 lg:hidden">
      {adherents.map((adherent) => (
        <article
          key={adherent.id}
          className="rounded-[1.75rem] border border-slate-200 bg-white p-4 shadow-lg shadow-slate-200/50 dark:border-white/10 dark:bg-slate-900 dark:shadow-black/20"
        >
          <div className="flex items-start gap-3">
            <img
              src={getAdherentPhoto(adherent)}
              alt={getAdherentName(adherent)}
              className="h-14 w-14 rounded-2xl object-cover"
              onError={(event) => {
                event.currentTarget.src = DEFAULT_AVATAR;
              }}
            />

            <div className="min-w-0 flex-1">
              <p className="font-bold text-slate-950 dark:text-white">
                {getAdherentName(adherent)}
              </p>

              <p className="mt-1 text-xs font-semibold text-slate-400">
                {adherent.club || "Club non renseigné"}
              </p>

              <div className="mt-3 flex flex-wrap gap-2">
                <span
                  className={`inline-flex min-h-8 items-center rounded-2xl px-3 text-xs font-bold ${getGenreStyle(
                    adherent.genre,
                  )}`}
                >
                  {adherent.genre || "Non spécifié"}
                </span>

                <span className="inline-flex min-h-8 items-center rounded-2xl bg-slate-100 px-3 text-xs font-bold text-slate-600 dark:bg-white/10 dark:text-white/60">
                  {getAgeLabel(adherent.date_naissance)}
                </span>
              </div>
            </div>
          </div>

          <div className="mt-4 grid gap-2 rounded-2xl bg-slate-50 p-3 dark:bg-white/[0.04]">
            <p className="text-sm font-semibold text-slate-600 dark:text-white/60">
              Naissance : {formatDateShort(adherent.date_naissance)}
            </p>

            <p className="text-sm font-semibold text-slate-600 dark:text-white/60">
              Département : {adherent.departement || "Non renseigné"}
            </p>

            <p className="inline-flex items-center gap-2 text-sm font-semibold text-slate-600 dark:text-white/60">
              <FaIdCard />
              Licence : {adherent.licence_number || "Non renseignée"}
            </p>
          </div>

          <button
            type="button"
            onClick={() => onOpen(adherent)}
            className="mt-4 inline-flex min-h-11 w-full items-center justify-center gap-2 rounded-2xl bg-blue-700 px-4 py-2 text-xs font-bold text-white transition hover:-translate-y-0.5 hover:bg-blue-800"
          >
            <FaEye />
            Voir la fiche
          </button>
        </article>
      ))}
    </section>
  );
}

export default AdherentsMobileList;